"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _formatNumber = _interopRequireDefault(require("format-number"));

var _Constants = require("../00_environment/Constants");

var _Container = _interopRequireDefault(require("../01_atoms/Container"));

var _BlockWithHeader = _interopRequireDefault(require("../01_atoms/BlockWithHeader"));

var _Bottom = _interopRequireDefault(require("../01_atoms/Bottom"));

var _Button = _interopRequireDefault(require("../01_atoms/Button"));

var _Divider = _interopRequireDefault(require("../01_atoms/Divider"));

var _ElementGroup = _interopRequireDefault(require("../01_atoms/ElementGroup"));

var _Element = _interopRequireDefault(require("../01_atoms/Element"));

var _HighligthedText = _interopRequireDefault(require("../01_atoms/HighligthedText"));

var _Icon = _interopRequireDefault(require("../01_atoms/Icon"));

var _LinkButton = _interopRequireDefault(require("../01_atoms/LinkButton"));

var _PaymentIcon = _interopRequireDefault(require("../01_atoms/PaymentIcon"));

var _BillingDetails = _interopRequireDefault(require("../02_molecules/BillingDetails"));

var _CovidDetails = _interopRequireDefault(require("../02_molecules/CovidDetails"));

var _OrderPriceDetails = _interopRequireDefault(require("../02_molecules/OrderPriceDetails"));

var _PassengerDetails = _interopRequireDefault(require("../02_molecules/PassengerDetails"));

var _TicketDetails = _interopRequireDefault(require("../02_molecules/TicketDetails"));

var _TripSeatDetailsTwoWays = _interopRequireDefault(require("../02_molecules/TripSeatDetailsTwoWays"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var formatPrice = function formatPrice(price) {
  return (0, _formatNumber["default"])({
    prefix: '$',
    round: 2,
    padRight: 2
  })(price);
};

var OrderDetailsWidget = function OrderDetailsWidget(_ref) {
  var sdk = _ref.sdk,
      history = _ref.history,
      numberOfPassengers = _ref.numberOfPassengers,
      selectedPassengers = _ref.selectedPassengers,
      userSavedCard = _ref.userSavedCard,
      payLink = _ref.payLink,
      passengerId = _ref.passengerId,
      outboundTrip = _ref.outboundTrip,
      returnTrip = _ref.returnTrip,
      payAmount = _ref.payAmount,
      onEditPassengers = _ref.onEditPassengers,
      onEditBillingDetails = _ref.onEditBillingDetails,
      onEditCovidDetails = _ref.onEditCovidDetails;
  var _sdk$i18n = sdk.i18n,
      translationManager = _sdk$i18n.translationManager,
      translatorForNamespace = _sdk$i18n.translatorForNamespace;
  var t = translatorForNamespace('CheckoutPageUI');
  var payLabel = t('Pay {amount}', {
    amount: formatPrice(payAmount)
  });
  var showSavedCard = !!userSavedCard && !!passengerId;

  if (showSavedCard) {
    payLabel = /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'inline-flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
      }
    }, /*#__PURE__*/_react["default"].createElement(_PaymentIcon["default"], {
      id: userSavedCard.brand.toLowerCase(),
      style: {
        display: 'inline',
        height: '1rem',
        marginRight: 5
      }
    }), " ".concat(payLabel, " "), "".concat(t('with card'), " *").concat(userSavedCard.last4));
  }

  var outboundTicketTitle = /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/_react["default"].createElement("span", null, "".concat(returnTrip ? t('Forward trip') : t('One-way trip'))), /*#__PURE__*/_react["default"].createElement("span", null, (numberOfPassengers > 1 ? "".concat(numberOfPassengers, "x ") : '') + formatPrice(outboundTrip.grossPrice)));

  var returnTicketTitle = returnTrip ? /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/_react["default"].createElement("span", null, t('Return trip')), /*#__PURE__*/_react["default"].createElement("span", null, (numberOfPassengers > 1 ? "".concat(numberOfPassengers, "x ") : '') + formatPrice(returnTrip.grossPrice))) : '';
  var highlight = null;

  if (sdk.covid19.isCovid19InfoFilled() && sdk.billingDetails.areBillingDetailsValid() && sdk.passengers.allPassengersSelectedAndValid() && sdk.seats.allSeatsSelectedAndValid(true)) {
    highlight = 'Checkout';
  } else if (sdk.covid19.isCovid19InfoFilled() && sdk.billingDetails.areBillingDetailsValid() && sdk.passengers.allPassengersSelectedAndValid()) {
    highlight = 'Seats';
  } else if (sdk.billingDetails.areBillingDetailsValid() && sdk.passengers.allPassengersSelectedAndValid()) {
    highlight = 'CovidDetails';
  } else if (sdk.passengers.allPassengersSelectedAndValid()) {
    highlight = 'BillingDetails';
  } else {
    highlight = 'PassengerDetails';
  }

  var title = /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'inline',
      marginLeft: 5
    }
  }, sdk.terminals.nameFromId(outboundTrip.origin), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: "arrow right",
    style: {
      display: 'inline',
      marginLeft: 5
    }
  }), "".concat(sdk.terminals.nameFromId(outboundTrip.destination)), "\xA0\xA0\xA0");

  var outboundSeats = sdk.seats.getSelectedSeats(false);
  var returnSeats = sdk.seats.getSelectedSeats(true);
  return /*#__PURE__*/_react["default"].createElement(_BlockWithHeader["default"], {
    ribbonContent: title,
    headerContent: /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        textAlign: 'left'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        fontSize: '1.6rem',
        fontWeight: '600',
        marginTop: 5,
        marginBottom: 2
      }
    }, formatPrice(payAmount)
    /* sdk.routes.humanPricingForRoute(outboundTrip, numberOfPassengers, false) */
    ), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        fontSize: '0.9rem',
        fontWeight: 'normal'
      }
    }, "".concat(numberOfPassengers, " ").concat(t('passenger')).concat(numberOfPassengers > 1 ? 's' : '')))
  }, /*#__PURE__*/_react["default"].createElement(_TicketDetails["default"], {
    title: outboundTicketTitle,
    ticketDetails: outboundTrip,
    nPassengers: numberOfPassengers,
    locale: translationManager.getCurrentLanguage()
  }), returnTrip && /*#__PURE__*/_react["default"].createElement(_TicketDetails["default"], {
    title: returnTicketTitle,
    ticketDetails: returnTrip,
    nPassengers: numberOfPassengers,
    locale: translationManager.getCurrentLanguage()
  }), /*#__PURE__*/_react["default"].createElement(_OrderPriceDetails["default"], {
    outboundTrip: outboundTrip,
    returnTrip: returnTrip,
    nPassengers: numberOfPassengers,
    translatorForNamespace: translatorForNamespace
  }), /*#__PURE__*/_react["default"].createElement(_PassengerDetails["default"], {
    title: t('Passengers'),
    translatorForNamespace: translatorForNamespace,
    passengers: selectedPassengers,
    translator: t,
    onEdit: onEditPassengers,
    highlightEditButton: highlight === 'PassengerDetails'
  }), /*#__PURE__*/_react["default"].createElement(_TripSeatDetailsTwoWays["default"], {
    sdk: sdk,
    hasReturn: !!returnTrip,
    outboundSeats: outboundSeats,
    returnSeats: returnSeats,
    onEditOutbound: function onEditOutbound() {
      history.push('/book/out/select/seats/');
    },
    onEditReturn: function onEditReturn() {
      history.push('/book/return/select/seats/');
    },
    translator: t,
    id: "seats-summary"
  }), /*#__PURE__*/_react["default"].createElement(_BillingDetails["default"], {
    sdk: sdk,
    title: t('Billing details'),
    translatorForNamespace: translatorForNamespace,
    translator: t,
    highlightEditButton: highlight === 'BillingDetails',
    onEdit: onEditBillingDetails
  }), /*#__PURE__*/_react["default"].createElement(_CovidDetails["default"], {
    sdk: sdk,
    title: t('Covid19-related information'),
    translatorForNamespace: translatorForNamespace,
    translator: t,
    onEdit: onEditCovidDetails,
    highlightEditButton: highlight === 'CovidDetails'
  }), /*#__PURE__*/_react["default"].createElement(_ElementGroup["default"], null, /*#__PURE__*/_react["default"].createElement(_Element["default"], null, t('Tickets are nominative.'), /*#__PURE__*/_react["default"].createElement("br", null), t("You'll need to present your"), ' ', /*#__PURE__*/_react["default"].createElement(_HighligthedText["default"], null, t('cedula or passport')), ' ', t('along with your ticket before boarding.')), /*#__PURE__*/_react["default"].createElement(_Element["default"], null, t("You'll receive your tickets"), ' ', /*#__PURE__*/_react["default"].createElement(_HighligthedText["default"], null, "".concat(t('by e-mail'), ".")), /*#__PURE__*/_react["default"].createElement("br", null), t('You can present your tickets either on the {appName} app or printed on paper.', {
    appName: _Constants.appName
  })), /*#__PURE__*/_react["default"].createElement(_Element["default"], null, "".concat(t('Tickets are'), " "), /*#__PURE__*/_react["default"].createElement(_HighligthedText["default"], null, t('not changeable')), " ".concat(t('and'), " "), /*#__PURE__*/_react["default"].createElement(_HighligthedText["default"], null, t('not refundable')), '. ', t('Please check your order twice before ordering.'))), highlight === 'Checkout' && /*#__PURE__*/_react["default"].createElement(_Bottom["default"], null, /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    to: payLink,
    primary: true,
    fluid: true
  }, payLabel), showSavedCard && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
    text: t('or')
  }), /*#__PURE__*/_react["default"].createElement(_LinkButton["default"], {
    to: "".concat(payLink, "new-card")
  }, t('Use another card'))))), highlight !== 'Checkout' && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      height: 30
    }
  }));
};

var _default = OrderDetailsWidget;
exports["default"] = _default;